import { Box, Stack } from '@mui/material'
import CustomText from 'components/common/CustomText/CustomText'
import React from 'react'
import { colors } from 'styles/colors'
import useGlobalStyles from 'styles/globalStyles'
import { CPT } from 'types/types/Types'

interface Props {
  item: any
}

export default function CPTItem({ item }: Props) {
  const globalStyles = useGlobalStyles();

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      p={1}
      borderRadius="10px"
      border={`1px solid ${colors.itemBorder}`}
    >
      <Box p={0.5} flex={1}>
        <Stack direction={'row'} alignItems={'center'}>
          <CustomText text={item?.cpt_lookup?.code || item?.code} color={colors.primary} />
          <CustomText text={`(×${item?.quantity})`} color={colors.primary} fontSize={15} ml={'2px'} />
        </Stack>

        <CustomText text={item?.cpt_lookup?.value || item?.value} color={colors.black} />
      </Box>
    </Box>
  )
}
